import type { AttributeGroupIn, AttributeGroupOut, ProductIn, ProductOutFull } from '@/shared/api/intranet'

const mapAttributeGroup = (attribute: AttributeGroupOut): AttributeGroupIn => ({
  id: attribute.id,
  name: attribute.id ? undefined : attribute.name,
  values: attribute.values.map(({ id, value }) => (id ? { id } : { value })),
})

export const mapProductOutFullToProductIn = (product: ProductOutFull, labelId: number | null): ProductIn => ({
  name: product.name,
  content: product.content,
  price: product.price,
  locations: product.locations ?? [],
  attachments: product.attachments,
  tag_ids: product.tag_ids,
  attributes: product.attributes.map(mapAttributeGroup),
  label_id: labelId,
})
